import React from 'react';
import { Star, StarHalf, Quote } from 'lucide-react';

const Reviews = () => {
  const reviews = [
    {
      text: 'Las pizzas a la parrilla son espectaculares. El sabor ahumado las hace únicas. Muy buenas porciones.',
      rating: 5,
    },
    {
      text: 'Excelente atención y las picadas son muy completas. Ideal para ir con amigos.',
      rating: 5,
    },
    {
      text: 'Gran variedad de cervezas y muy buena relación precio-calidad. Ambiente cómodo.',
      rating: 4,
    },
    {
      text: 'Las porciones son abundantes. La fugazzeta es imperdible. Siempre vuelvo.',
      rating: 5,
    },
  ];

  const renderStars = (rating) => {
    const stars = [];
    const fullStars = Math.floor(rating);
    const hasHalfStar = rating % 1 !== 0;

    for (let i = 0; i < fullStars; i++) {
      stars.push(<Star key={i} size={16} fill="#fbbf24" className="text-yellow-400" />);
    }
    if (hasHalfStar) {
      stars.push(<StarHalf key="half" size={16} fill="#fbbf24" className="text-yellow-400" />);
    }
    for (let i = stars.length; i < 5; i++) {
      stars.push(<Star key={i} size={16} className="text-gray-600" />);
    }
    return stars;
  };

  return (
    <section id="opiniones" className="py-16 md:py-24 bg-[#1a1a1a]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12 md:mb-16">
          <h2 className="font-heading text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-4">
            Lo que Dicen <span className="text-[#7cb342]">Nuestros Clientes</span>
          </h2>
          <div className="flex items-center justify-center gap-4 mb-4">
            <div className="flex items-center gap-1">
              {renderStars(4.5)}
            </div>
            <span className="font-heading text-2xl font-bold text-[#7cb342]">4.5</span>
            <span className="font-body text-gray-400">de 5</span>
          </div>
          <p className="font-body text-gray-400">
            Basado en <span className="text-[#7cb342] font-semibold">4.605 opiniones</span> en Google Maps
          </p>
        </div>

        {/* Reviews Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {reviews.map((review, index) => (
            <div 
              key={index}
              className="card-hover bg-[#252525] rounded-xl p-6 md:p-8 border border-[#333333] relative"
            >
              <Quote size={32} className="text-[#7cb342]/20 absolute top-4 right-4" />
              <div className="flex items-center gap-1 mb-4">
                {renderStars(review.rating)}
              </div>
              <p className="font-body text-gray-300 text-sm sm:text-base leading-relaxed">
                "{review.text}"
              </p>
            </div>
          ))}
        </div>

        {/* Google Maps CTA */}
        <div className="mt-12 text-center">
          <a
            href="https://maps.app.goo.gl/cosmeAlberdiRosario"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 text-[#7cb342] hover:text-[#9ccc65] font-body transition-colors"
          >
            <span>Ver todas las opiniones en Google Maps</span>
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
            </svg>
          </a>
        </div>
      </div>
    </section>
  );
};

export default Reviews;
